import { render, staticRenderFns } from "./SiteList.vue?vue&type=template&id=c961fc94&"
import script from "./SiteList.vue?vue&type=script&lang=js&"
export * from "./SiteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports